export enum RelEnum {
  NO_REL = 'null',
  REL_PREV = 'prev',
  REL_NEXT = 'next',
}
